module.exports = "https://web-assets.ifttt.com/packs/media/partners/right_arrow_sm-673b093d.svg";